import Cookies from "js-cookie";

import { environment, ENVIRONMENT } from "./environment";
import { envVars } from "./envVars";

const ENVIRONMENT_TO_API_ENDPOINT: Record<ENVIRONMENT, string | undefined> = {
  development: envVars.VITE_API_ENDPOINT_DEV,
  test: envVars.VITE_API_ENDPOINT_TEST,
  staging: envVars.VITE_API_ENDPOINT_STAGING,
  production: envVars.VITE_API_ENDPOINT_PROD,
};

export const getEndpoint = () => {
  const allowCookieEndpoint =
    import.meta.env.MODE === "development" || import.meta.env.MODE === "test";

  if (allowCookieEndpoint && Cookies.get("apiEndpoint")) {
    return Cookies.get("apiEndpoint")!;
  }

  return (
    ENVIRONMENT_TO_API_ENDPOINT[environment] ?? "https://rom.roqua.nl/graphql"
  );
};
